import { DataGrid } from "components/DataGrid/DataGrid";
import { useEffect, useState } from "react";
import { getTaskList } from "./api";
import { FormWithTitle } from "components/FormWithTitle/FormWithTitle";

interface searchPropsType {
    jobId?: string
    endpoint?: any

}
export const ReferencePositionsTask = ({jobId ,endpoint}: searchPropsType) => {

    const [TaskResponse, setTaskResponse] = useState<any>();
    const [TaskLoading, setTaskLoading] = useState<boolean>(false);
    let gridColumns, gridData = [];

    
    async function getTaskListAsync(){
        setTaskLoading(false);
        try {
            const res = await getTaskList( jobId ,endpoint); 
            setTaskResponse(res.Data)       
            
        } catch (error) { }
        setTaskLoading(true);
    }
    
    useEffect(() => {
      getTaskListAsync()
  }, []);



    if (TaskResponse && TaskResponse.length >0) {
        gridColumns = Object.keys(TaskResponse[0]);
        gridData = TaskResponse;
    }


return (          
  <>       
      {TaskLoading ?
      <>
    {((TaskResponse&& TaskResponse.length >0) )&&
    <div className="list-card mb-2">
    <FormWithTitle title="CurrentRefrences">
      <div className="mb-3">
        <DataGrid
          disabled={true}
          rowSelected=""
          parentName={"TaskList"}
          theadData={gridColumns}
          tbodyData={gridData}
          minCellWidth={80}
          startIndex={2}
          selectedRowObjectCallback={()=>{}}
          scrollHeight={"150px"}
          />
          </div>
        </FormWithTitle>
          </div>
          }
          </>
        :<></>}
      </>   
    )
}